import { g } from "../../util/index.ts";

// In an uncapped league, the luxury-tax line is a spending target, not an
// unlimited license to bid. Use the same target in automatic and disputed FA.
export const baseballBudget = () =>
	g.get("salaryCapType") === "none"
		? Math.max(g.get("salaryCap"), g.get("minPayroll"), g.get("luxuryPayroll"))
		: g.get("salaryCap");
